import { render, staticRenderFns } from "./finish-jg.vue?vue&type=template&id=4746453f&scoped=true"
import script from "./finish-jg.vue?vue&type=script&lang=js"
export * from "./finish-jg.vue?vue&type=script&lang=js"
import style0 from "./finish-jg.vue?vue&type=style&index=0&id=4746453f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746453f",
  null
  
)

export default component.exports